import { Poster } from "../Poster/Poster";
import { Category } from "./Category";

export const SingleCategory = () => {
return (
<>
<Poster />
<Category />
</>
);
}